import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { SharedService } from 'src/appv2/modules/shared/shared.service';
import { State } from '../ngrx/reducers';

@Injectable({
  providedIn: 'root'
})
export class SingleSessionGuard implements CanActivate {
  isNewTabOpen = false;
  storeSubscriber$: Subscription;
  constructor(
    private sharedService: SharedService,
    private router: Router,
    private store: Store<State>
  ) {
    this.storeSubscriber$ = this.store.select(state => state.newTabOpen)
      .subscribe((newTabOpen) => {
        this.isNewTabOpen = newTabOpen?.isNewTabOpen || JSON.parse(sessionStorage.getItem('isNewTabOpen') || 'false');
      });
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.isNewTabOpen) {
      this.router.navigate(['/session']);
      return false;
    }
    return true;
  }

  canLoad(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.isNewTabOpen) {
      this.router.navigate(['/session']);
      return false;
    }
    return true;
  }

  OnDestroy() {
    this.storeSubscriber$?.unsubscribe();
  }
}
